module.exports = __webpack_public_path__ + "img/weibo.e3025476.png";